import { tutorApiClient } from '../tutorApiClient';
import { TutorSearchResult } from '../models/Tutor';

type AxiosLikeError = {
  response?: {
    status?: number;
  };
};

/**
 * Resolve a single public tutor by id via `GET /v1/public/tutors/{tutorId}`.
 * Returns `null` when the tutor is missing or not publicly discoverable (404).
 */
export async function resolveTutorById(tutorId: string): Promise<TutorSearchResult | null> {
  try {
    return await tutorApiClient.getPublicTutorById(tutorId);
  } catch (error) {
    if ((error as AxiosLikeError)?.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
